import { render } from "./NotificationBlock.vue?vue&type=template&id=4c84c303&scoped=true"
import script from "./NotificationBlock.vue?vue&type=script&lang=js"
export * from "./NotificationBlock.vue?vue&type=script&lang=js"

import "./NotificationBlock.vue?vue&type=style&index=0&id=4c84c303&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c84c303"]])

export default __exports__